import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Link from "next/link";
import { useTranslation } from "react-i18next";

export function CreateProductButton({ trans_key }) {
	const { t } = useTranslation();

	return (
		<Link href={`/${trans_key}/create`} passHref>
			<Button startIcon={<AddIcon />} variant="contained" disableElevation>
				{t(`${trans_key}.manage.overview.bttn_create`)}
			</Button>
		</Link>
	);
}
